import { render, staticRenderFns } from "./InstructionBar.vue?vue&type=template&id=933768fc&scoped=true"
import script from "./InstructionBar.vue?vue&type=script&lang=js"
export * from "./InstructionBar.vue?vue&type=script&lang=js"
import style0 from "./InstructionBar.vue?vue&type=style&index=0&id=933768fc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933768fc",
  null
  
)

export default component.exports